export default function getTaxAmounts(taxItems) {
  if (!taxItems) return [];

  // tax_rate is whatever Stripe sent: an expanded TaxRate, a bare id string, or
  // null when it sent nothing. Only the expanded object carries these fields.
  const taxAmounts = taxItems.map(taxItem => ({
    amount: taxItem.amount, // total tax amount for this item
    inclusive: taxItem.inclusive, // whether the tax is included in the price
    country: taxItem.tax_rate?.country, // country code (alpha-2 e.g. US)
    displayName: taxItem.tax_rate?.display_name, // display name of the tax (e.g. VAT, GST, Sales tax)
    percentage: taxItem.tax_rate?.effective_percentage, // percentage of the tax
    jurisdiction: taxItem.tax_rate?.jurisdiction, // jurisdiction of the tax (e.g. Netherlands, California)
    taxType: taxItem.tax_rate?.tax_type, // type of tax (e.g. vat, gst)
  }));

  return taxAmounts;
}
